import config from 'config';
import { authHeader } from '@mobile/services/user';
import axios from '@mobile/util/axios';

export default {
    get,
    getAll,
};

async function get(todoId) {
    const response = await axios.get(
    	`${config.apiUrl}/${config.apiVersion}/todos/${todoId}`,
    	{ headers: authHeader() },
    );

    if (response && response.status == 200) {
        return response.data;
    }
}

async function getAll() {
    const response = await axios.get(
    	`${config.apiUrl}/${config.apiVersion}/todos`,
    	{ headers: authHeader() },
    );

    if (response && response.status == 200) {
        return response.data;
    }
}
